import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

import { Menu } from '../../components';

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  /* For small devices */
  ${breakpoint('xs', 'md')`
    flex-direction: column;
  `};

  ${Menu} {
    width: 35rem;

    margin-right: 3rem;

    /* For small devices */
    ${breakpoint('xs', 'md')`
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: baseline;

      position: fixed;
      bottom: 6rem;
      left: 0;

      height: 5.7rem;
      width: 100%;

      margin-right: 0;

      border-radius: 0;

    `};
  }
`;

export const Project = styled.div`
  width: 100%;
`;
